export default {
	methods: {
		server (response) {
			if (response.data.notifications) {
				for (let n of response.data.notifications) {
					this.$Message[n.type](n.text)
				}
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/mixins/server.js